var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "green-fitout-folders" },
    [
      _c("PostFitOutGuideline", {
        ref: "guidelineRef",
        attrs: {
          guidelines: _vm.currentFolders,
          enableExpandByClickingTitle: _vm.enableExpandByClickingTitle,
          expand: true,
        },
        scopedSlots: _vm._u([
          {
            key: "secTitle",
            fn: function (secTitleProps) {
              return [
                _c(
                  "HKLLeftRight",
                  { staticClass: "green-fitout-folders__title-box" },
                  [
                    _c(
                      "div",
                      { staticClass: "green-fitout-folders__title-left" },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(secTitleProps.section.displayOrder) +
                              ". " +
                              _vm._s(secTitleProps.section.value)
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c("HKLLeftRight", {
                      staticClass: "green-fitout-folders__title-right",
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "left",
                            fn: function () {
                              return [
                                _vm.canViewPoint &&
                                _vm.hasAccepted(
                                  secTitleProps.section.sectionContent
                                )
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "green-fitout-folders__point font-bold",
                                        class: {
                                          completed: _vm.isComplete(
                                            secTitleProps.section
                                          ),
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(
                                              _vm.totalPoints(
                                                secTitleProps.section
                                                  .sectionContent
                                              )
                                            ) +
                                            " " +
                                            _vm._s(
                                              _vm.$t(
                                                "tenantProjects.greenFitOut.pts"
                                              )
                                            ) +
                                            "\n            "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            },
                            proxy: true,
                          },
                          {
                            key: "right",
                            fn: function () {
                              return [
                                _vm.isComplete(secTitleProps.section) &&
                                !_vm.isTenant
                                  ? _c("HKLStatusBadge", {
                                      attrs: {
                                        color: "light-green",
                                        value: _vm._f("uppercase")(
                                          _vm.$t("status.complied")
                                        ),
                                      },
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.canReviewGreenFitout &&
                                !_vm.isComplete(secTitleProps.section)
                                  ? _c("HKLButton", {
                                      attrs: {
                                        color: "orange",
                                        action: "comply",
                                        disabled: !_vm.canComplete(
                                          secTitleProps.section
                                        ),
                                      },
                                      on: {
                                        click: function () {
                                          return _vm.complyPopupAction(
                                            secTitleProps.index
                                          )
                                        },
                                      },
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("HKLModal", {
                                  ref: "complyModal-" + secTitleProps.index,
                                  attrs: {
                                    okBtnAction: "yesComply",
                                    title: _vm.$t(
                                      "tenantProjects.greenFitOut.complyAlert"
                                    ),
                                    afterClose: _vm.resetClicking,
                                  },
                                  on: {
                                    onOkClick: function () {
                                      return _vm.complyAction(
                                        secTitleProps.index
                                      )
                                    },
                                  },
                                }),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                  ],
                  1
                ),
              ]
            },
          },
          {
            key: "item",
            fn: function (sectionItemProps) {
              return [
                _c("GreenFitOutSubFolders", {
                  attrs: {
                    folder: sectionItemProps.section,
                    subFolder: sectionItemProps.sectionItem,
                  },
                }),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }